import '../assets/NcIconToggleSwitch-sDZkWAmc.css';
import { defineComponent, useCssVars, computed } from "vue";
import { N as NcIconSvgWrapper } from "./NcIconSvgWrapper-Bui9PhAS.mjs";
import { n as normalizeComponent } from "./_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const svg = `<svg
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 24 12">
	<path d="M17,1H7A5,5 0 0,0 2,6 5,5 0 0,0 7,11H17A5,5 0 0,0 22,6 5,5 0 0,0 17,1Z" />
	<circle
		cy="6"
		r="3"
		fill="var(--color-main-background)" />
</svg>`;
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "NcIconToggleSwitch",
  props: {
    checked: { type: Boolean },
    size: { default: 34 },
    inline: { type: Boolean, default: false }
  },
  setup(__props) {
    const props = __props;
    useCssVars((_vm, _setup) => ({
      "2d1b8583": _setup.color,
      "78386a55": _setup.cx
    }));
    const color = computed(() => props.checked ? "var(--color-primary-element)" : "var(--color-text-maxcontrast)");
    const cx = computed(() => props.checked ? "calc(17 / 24 * 100%)" : "calc(7 / 24 * 100%)");
    return { __sfc: true, svg, props, color, cx, NcIconSvgWrapper };
  }
});
const iconToggleSwitch = "_iconToggleSwitch_ZSKWf";
const style0 = {
  "material-design-icon": "_material-design-icon_YB2B5",
  iconToggleSwitch
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.NcIconSvgWrapper, { class: _vm.$style.iconToggleSwitch, attrs: { "svg": _setup.svg, "size": _vm.size, "inline": _vm.inline } });
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcIconToggleSwitch = __component__.exports;
export {
  NcIconToggleSwitch as N
};
//# sourceMappingURL=NcIconToggleSwitch-0NTw7i-t.mjs.map
